import React, { useState, useCallback, useEffect, useRef } from "react";
import {
  Page,
  Card,
  PageActions,
  Text,
  Loading,
  Checkbox,
  FormLayout,
  TextField,
  InlineError,
  Toast,
  Button,
  Form,
  DropZone,
  Stack,
  Thumbnail,
  BlockStack,
  Modal,
  Spinner,
} from "@shopify/polaris";
import axios from "../../Assets/Lib/axios";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { NoteIcon } from "@shopify/polaris-icons";
import LoadingScreen from "../../Components/LoadingScreen";
import EllipsisText from "react-ellipsis-text";
import { Editor } from "@tinymce/tinymce-react";

const AddEditNotification = (props) => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [isSaving, setIsSaving] = useState(
    props.type === "edit" ? true : false
  );
  const [isImageUploading, setIsImageUploading] = useState(false);
  const [imagePreview, setImagePreview] = useState("");
  const [item, setItem] = useState({
    nameAr: "",
    nameEn: "",
    textEn: "",
    textAr: "",
  });
  const handleChangeNameEn = (newValue) => {
    setItem({ ...item, nameEn: newValue });
    setNameError("");
  };
  const [nameError, setNameError] = useState("");
  const handleChangeNameAr = (newValue) => {
    setItem({ ...item, nameAr: newValue });
    setNameError("");
  };

  const handleChangeTextEn = (newValue) => {
    setItem({ ...item, textEn: newValue });
    setTextError("");
  };
  const handleChangeTextAr = (newValue) => {
    setItem({ ...item, textAr: newValue });
    setTextError("");
  };
  const [textError, setTextError] = useState("");
  const handleChangeActive = (newValue) => {
    setItem({ ...item, isActive: newValue });
  };
  const [files, setFiles] = useState([]);

  const handleDropZoneDrop = useCallback(
    (_dropFiles, acceptedFiles, _rejectedFiles) =>
      setFiles((files) => [...files, ...acceptedFiles]),
    []
  );

  const validImageTypes = ["image/gif", "image/jpeg", "image/png"];

  const fileUpload = !files.length && (
    <DropZone.FileUpload
      actionHint={"Accepts pngs (Required size: 300x300 pixels)"}
    />
  );
  const uploadedFiles = files.length > 0 && (
    <div style={{ padding: "0" }}>
      <div className="rowDiv">
        <Thumbnail
          size="small"
          source={
            validImageTypes.includes(files[files.length - 1].type)
              ? window.URL.createObjectURL(files[files.length - 1])
              : NoteIcon
          }
        />
        <div>
          {files[files.length - 1].name}{" "}
          <Text variant="bodySm" as="p">
            {files[files.length - 1].size} bytes
          </Text>
        </div>
      </div>
    </div>
  );
  const [imageError, setImageError] = useState("");
  const [active, setActive] = useState(false);
  const toggleActive = useCallback(() => setActive((active) => !active), []);
  const toastMarkup = active ? (
    <Toast
      content="Changes have been saved successfully"
      onDismiss={toggleActive}
    />
  ) : null;

  const imageKey = useRef("");
  const sendImage = (files) => {
    setItem({
      ...item,
      image:
        validImageTypes.indexOf(files[files.length - 1].type) > 0
          ? window.URL.createObjectURL(files[files.length - 1])
          : "https://cdn.shopify.com/s/files/1/0757/9955/files/New_Post.png?12678548500147524304",
    });
    setImageError("");
    // setIsImageUploading(true);

    // const form_data = new FormData();
    // form_data.append("entity_type", "university");
    // form_data.append("image", files[files.length - 1]);
    // axios
    //   .post("/s3/save-file", form_data)
    //   .then((res) => {
    //     setIsImageUploading(false);
    //     setItem({
    //       ...item,
    //       image:
    //         validImageTypes.indexOf(files[files.length - 1].type) > 0
    //           ? window.URL.createObjectURL(files[files.length - 1])
    //           : "https://cdn.shopify.com/s/files/1/0757/9955/files/New_Post.png?12678548500147524304",
    //     });
    //     imageKey.current = res.data.data.file_key;
    //     setImageError("");
    //   })
    //   .catch((err) => console.log(err));
  };
  useEffect(() => {
    props.type === "edit" &&
      axios
        .get(`/notifications/${id}`)
        .then((result) => {
          console.log(result.data.data);
          setItem({
            nameEn:
              result?.data?.data?.title && result?.data?.data?.title?.en
                ? result.data.data.title.en
                : "",
            nameAr:
              result?.data?.data?.title && result?.data?.data?.title?.ar
                ? result.data.data.title.ar
                : "",
            textEn:
              result?.data?.data?.body && result?.data?.data?.body?.en
                ? result.data.data.body.en
                : "",
            textAr:
              result?.data?.data?.body && result?.data?.data?.body?.ar
                ? result.data.data.body.ar
                : "",
            isActive: result?.data?.data?.is_active ? true : false,
          });
          setIsSaving(false);
        })

        .catch((err) => console.log(err));
  }, []);
  return (
    <Page
      title={`${props.type === "add" ? "Add" : "Edit"} Notification`}
      backAction={{ onAction: () => navigate("/admin/notifications") }}
      narrowWidth
    >
      {isSaving ? <Loading /> : null}

      <Card sectioned>
        <FormLayout>
          <FormLayout.Group>
            <TextField
              value={item.nameEn}
              onChange={handleChangeNameEn}
              label="Title En"
            />
            <TextField
              value={item.nameAr}
              onChange={handleChangeNameAr}
              label="Title Ar"
              align="right"
            />
          </FormLayout.Group>
          <InlineError message={nameError} />
          <FormLayout.Group>
            <TextField
              value={item.textEn}
              onChange={handleChangeTextEn}
              label="Body En"
              multiline={4}
            />
            <TextField
              value={item.textAr}
              onChange={handleChangeTextAr}
              label="Body Ar"
              align="right"
              multiline={4}
            />
          </FormLayout.Group>
          <InlineError message={textError} />
        </FormLayout>
      </Card>

      <PageActions
        primaryAction={
          <Button variant="primary" onClick={handleSave}>
            {isSaving ? <Spinner size="small" /> : "Save"}
          </Button>
        }
        secondaryActions={
          props.type === "edit" && (
            <Button
              variant="primary"
              tone="critical"
              onClick={() => {
                setIsSaving(true);
                axios
                  .delete(`/notifications/${id}`)
                  .then((result) => {
                    navigate("/admin/notifications");
                  })
                  .catch((err) => console.log(err));
              }}
            >
              {isSaving ? <Spinner size="small" /> : "Delete"}
            </Button>
          )
        }
      />

      {/* <PageActions
        primaryAction={{
          content: "Save",
          onClick: handleSave,
          loading: isSaving && true,
        }}
        secondaryActions={
          props.type === "edit" && (
            <Button
              variant="primary"
              loading={isSaving}
              tone="critical"
              onClick={() => {
                setIsSaving(true);
                axios
                  .delete(`/notifications/${id}`)
                  .then((result) => {
                    navigate("/admin/notifications");
                  })
                  .catch((err) => console.log(err));
              }}
            >
              Delete
            </Button>
          )
        }
      /> */}
      {toastMarkup}
      {isImageUploading ? <LoadingScreen /> : null}
    </Page>
  );

  function handleSave() {
    if ((!item.nameEn && !item.nameAr) || (!item.textEn && !item.textAr)) {
      !item.nameEn && !item.nameAr && setNameError("Please add a title");
      !item.textEn && !item.textAr && setTextError("Please add a text");
    } else {
      setIsSaving(true);
      const form_data = new FormData();
      item.nameEn && form_data.append("title[en]", item.nameEn);
      item.nameAr && form_data.append("title[ar]", item.nameAr);
      item.textEn && form_data.append("body[en]", item.textEn);
      item.textAr && form_data.append("body[ar]", item.textAr);
      form_data.append("is_active", item.isActive ? 1 : 0);
      props?.type === "edit" && form_data.append("_method", "PATCH");
      props.type === "add"
        ? axios
            .post(`/notifications`, form_data)
            .then((result) => {
              navigate("/admin/notifications");
            })
            .catch((err) => console.log(err))
        : axios
            .post(`/notifications/${id}`, form_data)
            .then((result) => {
              navigate("/admin/notifications");
              // toggleActive();
              // setIsSaving(false);
            })
            .catch((err) => console.log(err));
    }
  }
};

export default AddEditNotification;
